"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Twilio;
    }
});
const _twilio = /*#__PURE__*/ _interop_require_default(require("twilio"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Twilio = class Twilio {
    async init() {
        this.client = (0, _twilio.default)(this.input.sid, this.input.token);
    }
    async sendMessage(content, payload) {
        var _payload_to;
        for (const num of (payload == null ? void 0 : (_payload_to = payload.to) == null ? void 0 : _payload_to.split(/\s*?,\s*?/)) || []){
            try {
                await this.client.messages.create({
                    body: content,
                    from: this.input.from,
                    to: num
                });
            } catch (e) {
                console.log(e);
                throw e;
            }
        }
    }
    constructor(input){
        this.input = input;
    }
};
